// import { useState } from "react";
// import { addRoom } from "../services/roomService";
// import { useNavigate } from "react-router-dom";

// export default function AddRoom() {
//   const navigate = useNavigate();

//   const [room, setRoom] = useState({
//     name: "",
//     type: "",
//     price: "",
//     desc: "",
//   });

//   const [imageBase64, setImageBase64] = useState("");

//   // Convert uploaded file → Base64
//   const convertToBase64 = (file) => {
//     const reader = new FileReader();
//     reader.onloadend = () => setImageBase64(reader.result);
//     reader.readAsDataURL(file);
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();

//     const newRoom = {
//       id: Date.now(),
//       ...room,
//       img: imageBase64, // Store Base64 image
//     };

//     addRoom(newRoom);
//     navigate("/manage-rooms");
//   };

//   return (
//     <div className="p-6 max-w-lg mx-auto">
//       <h1 className="text-3xl font-bold mb-6">Add Room</h1>

//       <form onSubmit={handleSubmit} className="flex flex-col gap-4">

//         <input
//           className="border p-2"
//           placeholder="Room Name"
//           onChange={(e) => setRoom({ ...room, name: e.target.value })}
//         />

//         <input
//           className="border p-2"
//           placeholder="Room Type"
//           onChange={(e) => setRoom({ ...room, type: e.target.value })}
//         />

//         <input
//           className="border p-2"
//           placeholder="Price"
//           onChange={(e) => setRoom({ ...room, price: e.target.value })}
//         />

//         <textarea
//           className="border p-2"
//           placeholder="Description"
//           onChange={(e) => setRoom({ ...room, desc: e.target.value })}
//         />

//         <input
//           type="file"
//           accept="image/*"
//           onChange={(e) => convertToBase64(e.target.files[0])}
//         />

//         {imageBase64 && (
//           <img src={imageBase64} className="w-40 mt-2 rounded" />
//         )}

//         <button className="bg-green-600 text-white p-3 rounded">
//           Add Room
//         </button>
//       </form>
//     </div>
//   );
// }

//UI DESIGN//

// import { useState } from "react";
// import { addRoom } from "../services/roomService";
// import { useNavigate } from "react-router-dom";

// export default function AddRoom() {
//   const navigate = useNavigate();

//   const [room, setRoom] = useState({
//     roomNumber: "",
//     roomType: "",
//     price: "",
//     capacity: "",
//     description: "",
//     image: "",
//   });

//   const convertToBase64 = (file) => {
//     const reader = new FileReader();
//     reader.onloadend = () =>
//       setRoom({ ...room, image: reader.result.split(",")[1] });
//     reader.readAsDataURL(file);
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     await addRoom(room);
//     navigate("/admin/manage-rooms");
//   };

//   return (
//     <div className="p-6 max-w-lg mx-auto">
//       <h2 className="text-2xl mb-4">Add Room</h2>

//       <form onSubmit={handleSubmit} className="flex flex-col gap-4">
//         <input
//           placeholder="Room Number"
//           className="border p-2"
//           onChange={(e) =>
//             setRoom({ ...room, roomNumber: e.target.value })
//           }
//         />

//         <input
//           placeholder="Room Type"
//           className="border p-2"
//           onChange={(e) =>
//             setRoom({ ...room, roomType: e.target.value })
//           }
//         />

//         <input
//           type="number"
//           placeholder="Price"
//           className="border p-2"
//           onChange={(e) => setRoom({ ...room, price: e.target.value })}
//         />

//         <input
//           type="number"
//           placeholder="Capacity"
//           className="border p-2"
//           onChange={(e) => setRoom({ ...room, capacity: e.target.value })}
//         />

//         <textarea
//           placeholder="Description"
//           className="border p-2"
//           onChange={(e) =>
//             setRoom({ ...room, description: e.target.value })
//           }
//         />

//         <input
//           type="file"
//           accept="image/*"
//           onChange={(e) => convertToBase64(e.target.files[0])}
//         />

//         <button className="bg-green-700 text-white p-2 rounded">
//           Add Room
//         </button>
//       </form>
//     </div>
//   );
// }


import { useState } from "react";
import { addRoom } from "../services/roomService";
import { useNavigate } from "react-router-dom";

export default function AddRoom() {
  const navigate = useNavigate();

  const [room, setRoom] = useState({
    roomNumber: "",
    roomType: "",
    price: "",
    capacity: "",
    name: "",
    description: "",
  });

  const [image, setImage] = useState("");

  const convertBase64 = (file) => {
    const reader = new FileReader();
    reader.onloadend = () => setImage(reader.result);
    reader.readAsDataURL(file);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const data = { ...room, image };

    await addRoom(data);

    navigate("/admin/manage-rooms");
  };

  return (
    <div className="p-4">
      <h2>Add Room</h2>

      <form onSubmit={handleSubmit}>

        <input
          placeholder="Room Number"
          className="form-control"
          onChange={(e) => setRoom({ ...room, roomNumber: e.target.value })}
        />

        <input
          placeholder="Room Type"
          className="form-control mt-2"
          onChange={(e) => setRoom({ ...room, roomType: e.target.value })}
        />

        <input
          type="number"
          placeholder="Price"
          className="form-control mt-2"
          onChange={(e) => setRoom({ ...room, price: e.target.value })}
        />

        <input
          type="number"
          placeholder="Capacity"
          className="form-control mt-2"
          onChange={(e) => setRoom({ ...room, capacity: e.target.value })}
        />

        <input
          placeholder="Name"
          className="form-control mt-2"
          onChange={(e) => setRoom({ ...room, name: e.target.value })}
        />

        <textarea
          placeholder="Description"
          className="form-control mt-2"
          onChange={(e) => setRoom({ ...room, description: e.target.value })}
        />

        <input
          type="file"
          className="form-control mt-3"
          onChange={(e) => convertBase64(e.target.files[0])}
        />

        {image && <img src={image} className="mt-2" width="120" />}

        <button className="btn btn-success mt-3">Add Room</button>
      </form>
    </div>
  );
}


